angular.module('impactx.panel').controller('LotPanelCtrl', [
    'TranslationService',
    '$redirect',
    'ThemeWorldService',
    'panelService',
    '$context',
    'AppConfiguration',
    'ProductViewService',
    'SearchFilterStorage',
    '$routeParams',
    LotPanelCtrl]);

function LotPanelCtrl(TranslationService, $redirect, ThemeWorldService, panelService, $context, AppConfiguration, ProductViewService,
                      SearchFilterStorage, $routeParams) {
    var self = this;
    self.trns = {
        addToThemeWorld: TranslationService.get('addToThemeWorld'),
        removeFromThemeWorld: TranslationService.get('removeFromThemeWorld'),
        addToProductView: TranslationService.get('addToProductView'),
        removeFromProductView: TranslationService.get('removeFromProductView')
    };

    self.getLotPanelColor = panelService.getLotPanelColor;

    self.showPanelLabel = AppConfiguration.get('showPanelLabels');

    self.redirectToLot = function() {
        if ($routeParams.useSetFilterList && SearchFilterStorage.getCurrentFilter()) {
            var filter = JSON.parse(JSON.stringify(SearchFilterStorage.getCurrentFilter()));
            filter.lotId = {value: self.lot.id};
            filter.dialogFilter = "lot";
            SearchFilterStorage.setLotFilter(self.lot.id, filter);
            $redirect.redirectTo(null, "lot/" + self.lot.id + "/true");
        }
        else {
            if (self.currentFilter) {
                var filter = JSON.parse(JSON.stringify(self.currentFilter));
                filter.lotId = {value: self.lot.id};
                filter.dialogFilter = "lot";
                filter.productPageNumber = 0;
                SearchFilterStorage.setLotFilter(self.lot.id, filter);
            }
            $redirect.redirectTo(null, "/lot/" + self.lot.id + (self.currentFilter ? "/true" : ""));
        }
    };

    self.addToThemeWorld = function($event) {
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.addLotsToThemeWorld([self.lot]);
    };

    self.removeFromThemeWorld = function($event) {
        var lotIds = [];
        self.lot.tw.add = true;
        self.lot.tw.remove = false;
        lotIds.push(self.lot.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.removeLotsFromThemeWorld($context.hasActiveThemeWorld.id, lotIds);
    };

    self.addToProductView = function($event) {
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.addLotsToProductView([self.lot]);
    };

    self.removeFromProductView = function($event) {
        var lotIds = [];
        self.lot.pv.add = true;
        self.lot.pv.remove = false;
        lotIds.push(self.lot.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.removeLotsFromProductView($context.hasActiveProductView.id, lotIds);
    };
}
